'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formatter = require('../common/formatter');

var _service = require('./service');

var _localParsedData = require('./lib/localParsedData.json');

var _localParsedData2 = _interopRequireDefault(_localParsedData);

var _util = require('./util');

var _formFieldUtils = require('../common/formFieldUtils');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var CASCADE_LEVEL = {
  DEFAULT: 3,
  CITY: 2,
  PROVINCE: 1
};

function walkTree(options, cache) {
  if (!cache) cache = {};

  if (options === null || options === undefined || !options.map) {
    return cache;
  }

  options.filter(function (item) {
    return !!item;
  }).forEach(function (item) {
    cache[item.value] = {
      label: item.text || item.label || item.value,
      value: item.value
    };
    if (!(0, _lodash.isEmpty)(item.children)) {
      walkTree(item.children, cache);
    }
  });

  return cache;
}

var AddressSelectField = (_temp = _class = function (_Field) {
  _inherits(AddressSelectField, _Field);

  function AddressSelectField(props) {
    _classCallCheck(this, AddressSelectField);

    // 用本地数据源构造地址 cache
    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _this.getRealOptions = function () {
      var useLocal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return !useLocal && _this.isAsyncOptions() ? _this.state.dataSource : _this.state.localOptions;
    };

    _this.onLoadData = function (selected) {
      var _this$props = _this.props,
          includeCitySelf = _this$props.includeCitySelf,
          addressType = _this$props.addressType,
          areas = _this$props.areas;
      var prevDataSource = _this.state.dataSource;

      var dataSource = (0, _lodash.cloneDeep)(prevDataSource);
      var code = selected ? selected.value : 0;
      return (0, _service.queryRegion)(code, includeCitySelf).then(function (data) {
        if ((0, _lodash.isEmpty)(data)) {
          return false;
        }
        var options = (0, _util.convertDataSource)(data, CASCADE_LEVEL[addressType]);
        if (code === 0) {
          dataSource = options;
          if (areas && areas.type === 'CUSTOM') {
            var provinces = areas.provinces || [];
            dataSource = dataSource.filter(function (item) {
              return provinces.includes(String(item.value));
            });
          }
        } else {
          var pos = selected.pos.split('-');
          pos.shift();
          var current = pos.reduce(function (source, current, index) {
            return index === pos.length - 1 ? source[current] : source[current].children;
          }, dataSource);
          current.children = options;
        }
        _this.setState({ dataSource: dataSource });
      });
    };

    var localOptions = _this.getLocalOptions();
    _this.addressCache = walkTree(localOptions) || {};
    _this.state = _extends({}, _this.state, { dataSource: [], localOptions: localOptions });
    return _this;
  }

  AddressSelectField.prototype.componentDidMount = function componentDidMount() {
    _Field.prototype.componentDidMount.call(this);
    if (this.isAsyncOptions()) {
      this.onLoadData();
    }
  };

  AddressSelectField.prototype.isAsyncOptions = function isAsyncOptions() {
    var asyncOptions = this.props.asyncOptions;

    return asyncOptions;
  };

  AddressSelectField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-address'
    });
  };

  /**
   * 获取组件的选项
   */
  AddressSelectField.prototype.getLocalOptions = function getLocalOptions() {
    var areas = this.props.areas;

    var json = (0, _util.getDistrictData)('zh_CN', _localParsedData2.default);

    var provinces = [];
    if (areas && areas.type === 'CUSTOM') provinces = areas.provinces;else provinces = json.map(function (i) {
      return i.value;
    });

    var options = [];
    // 省过滤
    provinces.map(function (p) {
      options.push(json.find(function (i) {
        return i.value === p;
      }));
    });

    return this.addCitySelfToCountyOptions(this.preprocessDistrictData(options));
  };

  // onChange时触发，组件的值向全局store中赋值时的转换


  AddressSelectField.prototype.formatOut = function formatOut(value, data, extra) {
    return (0, _formatter.formatOut)(value, 'CascadeSelect', data, extra);
  };

  AddressSelectField.prototype.fieldDataFormatter = function fieldDataFormatter(value) {
    var options = this.getRealOptions(true);
    return (0, _formatter.fieldDataFormatter)(value, 'CascadeSelect', options);
  };

  AddressSelectField.prototype.defaultValueFormatter = function defaultValueFormatter(value) {
    if (Array.isArray(value) && !(0, _lodash.isEmpty)(value)) {
      return value.map(function (item) {
        return item.text;
      }).join('/');
    }
    return value;
  };

  // 根据不同的选择器类型，删除额外的数据


  AddressSelectField.prototype.preprocessDistrictData = function preprocessDistrictData(options) {
    var results = (0, _lodash.cloneDeep)(options);
    switch (this.props.addressType) {
      case 'PROVINCE':
        results = (0, _util.removeChildren)((0, _lodash.cloneDeep)(options));
        break;
      case 'CITY':
        results = (0, _util.removeChildrenL2)((0, _lodash.cloneDeep)(options));
        break;
      default:
        break;
    }
    return results;
  };

  // 添加市本级


  AddressSelectField.prototype.addCitySelfToCountyOptions = function addCitySelfToCountyOptions(provinces) {
    var includeCitySelf = this.props.includeCitySelf;

    if (!includeCitySelf) return provinces;
    return provinces.map(function (province) {
      return {
        label: province.label,
        value: province.value,
        children: (province.children || []).map(function (city) {
          return {
            label: city.label,
            value: city.value,
            children: [{
              label: '市辖区',
              value: city.value.slice(0, 5) + '1'
            }].concat(city.children || [])
          };
        })
      };
    });
  };

  /**
   * 当前选中的节点数据 value/label/children/pos
   * 返回下一层的数据，然后自行拼装完整的数据
   */


  AddressSelectField.prototype.renderControl = function renderControl() {
    var _this2 = this;

    var _props = this.props,
        _onChange = _props.onChange,
        isMustSelectLeaf = _props.isMustSelectLeaf,
        showSearch = _props.showSearch,
        notFoundContent = _props.notFoundContent,
        _props$autoWidth = _props.autoWidth,
        autoWidth = _props$autoWidth === undefined ? false : _props$autoWidth;

    var controlProps = this.getControlProps();

    var listStyle = (0, _formFieldUtils.isIE)() ? { width: '150px' } : { minWidth: '150px', width: 'auto' };
    if (autoWidth) {
      var cascadeSize = 3; // this.getCascadeSize();
      listStyle = { width: 1 / cascadeSize * 100 + '%' };
    }

    var fieldProps = _extends({}, controlProps, {
      showSearch: showSearch,
      notFoundContent: notFoundContent,
      autoWidth: autoWidth,
      listStyle: listStyle,
      dataSource: this.getRealOptions(),
      valueRender: function valueRender(item) {
        var fieldValue = _this2.getFieldValue();
        if (!(0, _lodash.isEmpty)(fieldValue)) {
          return fieldValue.map(function (item) {
            if (item && (item.text || item.label) && item.text !== item.value) {
              return item.text || item.label;
            } else if (item && item.value) {
              return _this2.addressCache[item.value] && _this2.addressCache[item.value]['label'] || item.value;
            } else {
              return item || '';
            }
          }).join('/');
        }
        return '';
      },
      canOnlyCheckLeaf: isMustSelectLeaf,
      style: _extends({}, controlProps.style, { width: '100%' }),
      onChange: function onChange(value, data, extra) {
        _onChange({ value: _this2.formatOut(value, data, extra) });
      }
    });
    if (this.isAsyncOptions()) {
      fieldProps.loadData = this.onLoadData;
    }

    return _react2.default.createElement(_next.CascaderSelect, fieldProps);
  };

  return AddressSelectField;
}(_vuFusionField2.default), _class.displayName = 'AddressSelect', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  notFoundContent: '无选项',
  autoWidth: false,
  asyncOptions: false
}), _temp);
exports.default = AddressSelectField;
module.exports = exports['default'];